import React, { useEffect, useState } from 'react';
import Styles from './BensServicosPFParcelaFacilitada.css';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import { isBrowser, isMobile } from '@/utils/browser';

function BensServicosPFParcelaFacilitada() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  const updateCarouselContainer = () => {
    const el = document.querySelector('#container-parcela .parcela-facilitada-textos-carrossel');

    if (isMobile()) {
      el.style.width = '100%';
      return;
    }

    const ref = document.getElementById('container-reference');

    if (ref) {
      const style = window.getComputedStyle(ref);
      const m = style.marginLeft;
      try {
        el.style.width = `calc(100% - ${m})`;
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  };

  useEffect(() => {
    if (!isBrowser()) return;

    window.addEventListener('resize', updateCarouselContainer);

    updateCarouselContainer();
    return () => {
      updateCarouselContainer();
      window.removeEventListener('resize', updateCarouselContainer);
    };
  }, []);

  return (
    <>
      <section id="bens-servicos-pf-parcela-facilitada">
        <ContainerHome24 id="container-parcela">
          <div className="parcela-facilitada-textos-carrossel">
            <div className="parcela-facilitada-textos">
              <h2 className="parcela-facilitada-textos-titulo">
                Parcela facilitada com a Santander Financiamentos
              </h2>
              <p className="parcela-facilitada-textos-conteudo">
                Realizar seus sonhos pode estar mais perto do que você imagina. Com a gente, você
                transforma planos em conquistas, com praticidade, segurança e parcelas que cabem no
                seu dia a dia.
                <br />
                <br />
                Confira tudo o que você pode parcelar com a gente:
                <br />
                <ul>
                  <li>Viagens e turismo</li>
                  <li>Móveis e decoração</li>
                  <li>Equipamentos médicos</li>
                </ul>
              </p>
            </div>
            <div className="parcela-facilitada-carrossel">
              {/* Radio escondido para "desvirar" os cards */}
              <input type="radio" name="flip-card" id="none" className="flip-toggle" hidden />
              <CustomEmblaCarouselHome24
                enableBullets
                detectBulletCount
                enableMobileArrows
                enablePrevArrow
                wheelGestures
              >
                {({ className }) => (
                  <>
                    {/* CARD 1 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Viagens e turismo
                            </p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo.png"
                                  alt="Mulher em aeroporto com laptop, passaporte e mala, representando soluções da Santander Financiamentos como crédito pessoal, empréstimo para empresas e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/viagens-e-turismo-desk.png"
                                  alt="Mulher em aeroporto com laptop, passaporte e mala, representando soluções da Santander Financiamentos como crédito pessoal, empréstimo para empresas e bens e serviços parcelados."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Viagens e turismo
                            </p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">
                                Viagem que cabe
                                <br /> no seu bolso
                              </p>
                              <p className="flip-card-back-infos-text">
                                Sua próxima viagem começa aqui! Com o Santander Financiamentos, você
                                tem mais de 40 parceiros para escolher e parcelar a viagem dos seus
                                sonhos.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>

                    {/* CARD 2 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Móveis e decoração
                            </p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes.png"
                                  alt="Casal em nova residência com caixas de mudança, representando conquistas viabilizadas por parcelamento de bens e serviços com Santander Financiamentos."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/moveis-e-decoracoes-desk.png"
                                  alt="Casal em nova residência com caixas de mudança, representando conquistas viabilizadas por parcelamento de bens e serviços com Santander Financiamentos."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Móveis e decoração
                            </p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">Sua casa de cara nova</p>
                              <p className="flip-card-back-infos-text">
                                Renove sua casa com a Santander Financiamentos! Mais de 7 mil
                                parceiros para mobiliar e decorar. Parcele no boleto ou débito
                                automático, do seu jeito.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>

                    {/* CARD 3 */}
                    <div className={`parcela-facilitada-carrossel-slide ${className}`}>
                      <label className="flip-card">
                        <input type="radio" name="flip-card" className="flip-toggle" />
                        <div className="flip-card-inner">
                          <div className="flip-card-front parcela-facilitada-carrossel-card">
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Equipamentos médicos
                            </p>
                            {width <= 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf.png"
                                  alt="Pessoa em ambiente hospitalar com tablet próximo a equipamento médico, representando acesso facilitado a crédito pessoal, financiamento e bens e serviços parcelados com Santander Financiamentos."
                                />
                              </picture>
                            )}
                            {width > 992 && (
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf-desk.webp"
                                />
                                <source
                                  type="image/png"
                                  srcSet="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf-desk.png"
                                />
                                <img
                                  src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/equipamentos-medicos-pf-desk.png"
                                  alt="Pessoa em ambiente hospitalar com tablet próximo a equipamento médico, representando acesso facilitado a crédito pessoal, financiamento e bens e serviços parcelados com Santander Financiamentos."
                                />
                              </picture>
                            )}
                            <p className="parcela-facilitada-carrossel-slide-link">Saiba mais</p>
                          </div>
                          <label
                            htmlFor="none"
                            className="flip-card-back parcela-facilitada-carrossel-card"
                          >
                            <p className="parcela-facilitada-carrossel-slide-titulo">
                              Equipamentos médicos
                            </p>
                            <div className="flip-card-back-infos">
                              <img
                                src="assets/bens-e-servicos/parcela-facilitada-carrossel-slide/ic_close_card.svg"
                                alt=""
                                className="ic-close-card"
                              />
                              <p className="flip-card-back-infos-title">Seu consultório completo</p>
                              <p className="flip-card-back-infos-text">
                                Seu consultório merece o melhor. Com a Santander Financiamentos,
                                você escolhe entre mais de 450 parceiros para encontrar os
                                equipamentos médicos ideais.
                              </p>
                            </div>
                            <p className="parcela-facilitada-carrossel-slide-link flip-card-back-link">
                              Saiba mais
                            </p>
                          </label>
                        </div>
                      </label>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
        </ContainerHome24>
        <ContainerHome24 id="container-reference">
          <div className="parcela-facilitada-numbers">
            <div className="parcela-facilitada-numbers-cards">
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>800 mil
                </p>
                <p className="numbers-card-text">financiamentos por ano</p>
              </div>
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>34 mil
                </p>
                <p className="numbers-card-text">lojas parceiras</p>
              </div>
              <div className="parcela-facilitada-numbers-card">
                <p className="numbers-card-number">
                  <b>+</b>60 anos
                </p>
                <p className="numbers-card-text">de experiência</p>
              </div>
            </div>
            <RedButton href="#bens-servicos-busca-loja" className="btn-lojas-parceiras">
              Ver lojas parceiras
            </RedButton>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosPFParcelaFacilitada;
